import mutationFactory from '../../lib/mutationFactory';

export default {
  ...mutationFactory({
    singular: 'invoiceCapture',
    plural: 'invoiceCaptures'
  }),

  UPLOAD_FILE_REQUEST: state => {
    state.loadingAction.uploadFile = true;
    state.errorAction.uploadFile = false;
  },
  UPLOAD_FILE_PROGRESS: (state, progress) => {
    state.progressAction.uploadFile = progress;
  },
  UPLOAD_FILE_SUCCESS: state => {
    state.loadingAction.uploadFile = false;
    state.errorAction.uploadFile = false;
    state.progressAction.uploadFile = 0;
  },
  UPLOAD_FILE_ERROR: (state, error) => {
    state.loadingAction.uploadFile = false;
    state.errorAction.uploadFile = error;
    state.progressAction.uploadFile = 0;
  },

  DOWNLOAD_FILE_REQUEST: state => {
    state.loadingAction.downloadFile = true;
    state.errorAction.downloadFile = false;
  },
  DOWNLOAD_FILE_SUCCESS: state => {
    state.loadingAction.downloadFile = false;
    state.errorAction.downloadFile = false;
  },
  DOWNLOAD_FILE_ERROR: (state, error) => {
    state.loadingAction.downloadFile = false;
    state.errorAction.downloadFile = error;
  },

  START_CAPTURE_REQUEST: state => {
    state.loadingAction.startCapture = true;
    state.errorAction.startCapture = false;
  },
  START_CAPTURE_SUCCESS: state => {
    state.loadingAction.startCapture = false;
    state.errorAction.startCapture = false;
  },
  START_CAPTURE_ERROR: (state, error) => {
    state.loadingAction.startCapture = false;
    state.errorAction.startCapture = error;
  },

  START_VALIDATION_REQUEST: state => {
    state.loadingAction.startValidation = true;
    state.errorAction.startValidation = false;
  },
  START_VALIDATION_SUCCESS: state => {
    state.loadingAction.startValidation = false;
    state.errorAction.startValidation = false;
  },
  START_VALIDATION_ERROR: (state, error) => {
    state.loadingAction.startValidation = false;
    state.errorAction.startValidation = error;
  }
};
